import { render, staticRenderFns } from "./PriceWorkflowCustomDiscount.vue?vue&type=template&id=e0940382&"
import script from "./PriceWorkflowCustomDiscount.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowCustomDiscount.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowCustomDiscount.vue?vue&type=style&index=0&id=e0940382&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports